export function createModule (platform, { capturedGet, capturedPost, capturedPut, capturedRemove } = {}) {
  const state = {}
  const getters = {}
  const mutations = {}
  const actions = {
    async getPromotionData (context, { params }) {
      return capturedGet(`/${platform}/promotion-data/index`, params)
    },
    async getSelectData (context, { params }) {
      return capturedGet(`/${platform}/promotion-data/option`, params)
    }
  }

  return {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
}
